import React, {createContext, useContext, useMemo, useState, useEffect} from "react";

const AuthCtx = createContext(null);
const LS_KEY = "petrah:isAuthed";

export function AuthProvider({children}) {
  const [isAuthed, setIsAuthed] = useState(false);

  useEffect(() => {
    setIsAuthed(localStorage.getItem(LS_KEY) === "1");
  }, []);

  const login = (username, password) => {
    // 🔒 Hard-coded credentials
    const ok = username === "admin" && password === "Petrah@2025";
    if (ok) {
      localStorage.setItem(LS_KEY, "1");
      setIsAuthed(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem(LS_KEY);
    setIsAuthed(false);
  };

  const value = useMemo(() => ({ isAuthed, login, logout }), [isAuthed]);
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  return useContext(AuthCtx);
}
